module.exports = __webpack_public_path__ + "static/media/promo_band_3.bed83943.jpg";